module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    staticClass: "chapter",
    attrs: {
      "epub:type": "copyright-page",
      "id": "cip"
    }
  }, [_c('p', {
    staticClass: "crt"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "piv"
    }
  }), _vm._v("New York and London")]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_c('a', {
    staticClass: "url",
    attrs: {
      "href": "http://www.nyupress.org",
      "target": "_blank"
    }
  }, [_vm._v("www.nyupress.org")])]), _vm._v(" "), _c('p', {
    staticClass: "crtf"
  }, [_vm._v("Copyright © 1990 by New York University")]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_vm._v("All rights reserved")]), _vm._v(" "), _c('p', {
    staticClass: "crtf"
  }, [_vm._v("First published in paperback in 2007.")]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_vm._v("New revised edition published in 2015.")]), _vm._v(" "), _c('p', {
    staticClass: "crtf"
  }, [_vm._v("e-ISBN: 978-1-4798-6995-4")]), _vm._v(" "), _c('p', {
    staticClass: "cipf"
  }, [_vm._v("Library of Congress Cataloging-in-Publication Data")]), _vm._v(" "), _c('p', {
    staticClass: "cip"
  }, [_vm._v("Skousen, Mark.")]), _vm._v(" "), _c('p', {
    staticClass: "cip1"
  }, [_vm._v("The structure of production / Mark Skousen; with a new introduction. — New revised edition.")]), _vm._v(" "), _c('p', {
    staticClass: "cip2"
  }, [_vm._v("pages cm")]), _vm._v(" "), _c('p', {
    staticClass: "cip1"
  }, [_vm._v("Includes bibliographical references and index.")]), _vm._v(" "), _c('p', {
    staticClass: "cip1"
  }, [_vm._v("ISBN 978-1-4798-4852-2 (pb: alk. paper)")]), _vm._v(" "), _c('p', {
    staticClass: "cip1"
  }, [_vm._v("1. Production (Economic theory) 2. Macroeconomics. I. Title.")]), _vm._v(" "), _c('p', {
    staticClass: "cipf1"
  }, [_vm._v("HB241.S63 2015")]), _vm._v(" "), _c('p', {
    staticClass: "cipf1"
  }, [_vm._v("338.5—dc23")]), _vm._v(" "), _c('p', {
    staticClass: "cip1f"
  }, [_vm._v("2015006888")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0a870508","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/nyu-skousen-0004.vue
// module id = 63
// module chunks = 0